import { render, staticRenderFns } from "./postageOrder.vue?vue&type=template&id=3f924a94&scoped=true&"
import script from "./postageOrder.vue?vue&type=script&lang=js&"
export * from "./postageOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f924a94",
  null
  
)

export default component.exports